export default __webpack_public_path__ + "static/media/content.beeba098.png";